import { DateTime, DateTimeFormatOptions } from 'luxon';

type FormatTimeOptions = {
  formatOptions?: DateTimeFormatOptions;
  timezone?: string;
  onUnknown?: string;
};

export const formatTime = (isoDate: string | Date | null | undefined, options?: FormatTimeOptions): string => {
  if (isoDate === null || isoDate === undefined) {
    return options?.onUnknown ?? '';
  }

  let parsed: DateTime = DateTime.fromISO(isoDate as string);
  if (!parsed.isValid) {
    parsed = DateTime.fromJSDate(isoDate as Date);
  }

  if (!parsed.isValid) {
    throw new Error('Invalid input date is not specified');
  }

  if (options?.timezone) {
    parsed = parsed.setZone(options.timezone);
  }

  const formatOptions = options?.formatOptions ? options.formatOptions : {};

  return parsed.toLocaleString(formatOptions);
};
